module.exports = __webpack_public_path__ + "static/media/restaurant.82f6e5cc.png";